(() => {
  if (window.siennaCartTimerBound) return;
  window.siennaCartTimerBound = true;
  const key = 'sienna_cart_timer_deadline_v1';
  let deadline = 0;
  const read = () => { try { return Number(sessionStorage.getItem(key)) || 0; } catch { return deadline; } };
  const write = value => { deadline = value; try { value ? sessionStorage.setItem(key, String(value)) : sessionStorage.removeItem(key); } catch {} };
  const update = () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    const timer = drawer.querySelector('[data-sienna-cart-timer]');
    if (!timer) { if (drawer.classList.contains('is-empty')) write(0); return; }
    if (!read()) write(Date.now() + 600000);
    const seconds = Math.max(0, Math.ceil((read() - Date.now()) / 1000));
    const clock = timer.querySelector('[data-sienna-cart-clock]');
    if (clock) clock.textContent = String(Math.floor(seconds / 60)).padStart(2, '0') + ':' + String(seconds % 60).padStart(2, '0');
    const ended = timer.querySelector('.sienna-cart-timer-ended');
    if (ended) ended.hidden = seconds > 0;
  };
  const drawer = document.querySelector('cart-drawer');
  if (drawer) new MutationObserver(update).observe(drawer, {childList: true, subtree: false, attributes: true, attributeFilter: ['class']});
  setInterval(update, 1000);
  update();
})();